module.exports = __webpack_public_path__ + "static/media/nb_akademie_bold_italic-webfont.0d71bcf8.ttf";